import { FC } from 'react';
import { Typography, Tooltip, theme } from 'antd';
import { useSnapshot } from 'valtio';

import FlexBox from '../../atoms/FlexBox';
import { formStore } from '../../../store';

const { Text } = Typography;

/**
 * FormTypeLabel
 *
 * Leading item of the `FormControl` bar: the open form's type — Quote, Order,
 * Invoice. The same label is rendered inside the form body by `FormPropsUI`,
 * which scrolls out of view; `FormControl` is sticky, so this is the copy that
 * keeps telling the user which kind of form they are on (SYD-2347).
 *
 * Reads only the `formType` description leaves off the store snapshot, so a
 * field-value write never re-renders it. Falls back to the form type's `docId`
 * when the type carries no `shortLabel`, matching `FormPropsUI`.
 *
 * The box is `controlHeight` tall so the label centres against the selects
 * beside it, which the `alignStart` row in `FormControl` would otherwise leave
 * it floating above.
 */
const FormTypeLabel: FC = () => {
  const { token } = theme.useToken();
  const snap = useSnapshot(formStore.state);
  const shortLabel = snap.formType.data?.description?.shortLabel;
  const docId = snap.formType.data?.docId;
  const longDescription = snap.formType.data?.description?.longDescription;

  return (
    <FlexBox
      noGrow
      style={{ height: token.controlHeight }}
    >
      <Tooltip
        title={longDescription}
      >
        <Text strong>{shortLabel || docId || ''}</Text>
      </Tooltip>
    </FlexBox>
  );
};

export default FormTypeLabel;
